<template>
   <div class="relative size-full">
      <div
         v-show="isLoading"
         class="skeleton bg-light-grey absolute inset-0 overflow-hidden transition-opacity duration-300"
         :class="{
            'opacity-0': !isLoading,
            'opacity-100': isLoading,
         }"
         :style="{
            width: computedWidth,
            height: computedHeight,
            borderRadius: borderRadius,
         }"
      >
         <div
            class="shimmer via-grey/20 absolute inset-0 bg-gradient-to-r from-transparent to-transparent"
         />
      </div>

      <div
         class="size-full transition-opacity duration-300"
         :class="{
            'opacity-0': isLoading,
            'opacity-100': !isLoading,
         }"
      >
         <slot />
      </div>
   </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

type Props = {
   loading?: boolean
   width?: string | number
   height?: string | number
   borderRadius?: string
}

const props = withDefaults(defineProps<Props>(), {
   width: '100%',
   height: '200px',
   borderRadius: '12px',
})

const isLoading = computed(() => props.loading)

const computedWidth = computed(() =>
   typeof props.width === 'number' ? `${props.width}px` : props.width
)

const computedHeight = computed(() =>
   typeof props.height === 'number' ? `${props.height}px` : props.height
)
</script>

<style lang="postcss" scoped>
.skeleton {
   animation: pulse 1.5s infinite ease-in-out;

   & .shimmer {
      animation: shimmer 1.5s ease-in-out infinite;
   }
}

@keyframes pulse {
   0% {
      @apply opacity-100;
   }
   50% {
      @apply opacity-40;
   }
   100% {
      @apply opacity-100;
   }
}

@keyframes shimmer {
   from {
      transform: translateX(-100%);
   }
   to {
      transform: translateX(100%);
   }
}
</style>
